// Import React and required components, images, and styles
import React from "react";
import Hero from "./components/Hero";
import HeroImage from "../assets/images/businesswoman-reading-message-mobile-phone.jpg";
import "../css/PrivacyPage.css";

// PrivacyPage component displays the privacy policy information for users
function PrivacyPage() {
  return (
    <>
      {/* Hero section with background image and title */}
      <Hero
        title={"Privacy Policy"}
        subtitle={""}
        backgroundImage={HeroImage}
      />

      {/*
        Address section (commented out):
        Uncomment if you want to display correspondence and FCA registered addresses
      */}
      {/*
      <div className="address-section">
        <div className="address-card">
          <h4>Correspondence Address</h4>
          <p>
            Arum House,
            <br />
            21 Mill Rise, Robertsbridge,
            <br />
            East Sussex,
            <br />
            TN32 5EF
          </p>
        </div>
        <div className="address-card">
          <h4>FCA Registered Address </h4>
          <p>
            Rosemount House
            <br />
            2–4 Chequers Road 
            <br />
            Basingstoke 
            <br />
            RG21 7PU 
          </p>
        </div>
      </div>
      */}

      {/* Main privacy policy content container */}
      <div className="privacy-container">
        <h3>Why should you read this document?</h3>{" "}
        <p>
          {" "}
          During the course of dealing with us we will ask you to provide us
          with detailed personal information relating to your existing
          circumstances, your financial situation and, in some cases, your
          health and family health history (Your Personal Data). This document
          is important as it allows us to explain to you what we will need to do
          with Your Personal Data, and the various rights you have in relation
          to Your Personal Data.
        </p>{" "}
        <h3>What do we mean by “Your Personal Data”?</h3>
        <p>
          {" "}
          Your Personal Data means any information that describes or relates to
          your personal circumstances. Your Personal Data may identify you
          directly, for example your name, address, date of birth, national
          insurance number. Your Personal Data may also identify you indirectly,
          for example, your employment situation, your physical and mental
          health history, or any other information that could be associated with
          your cultural or social identity. In the context of providing you with
          assistance with your personal advice requirements, your Personal Data
          may include:{" "}
        </p>{" "}
        <p>
          - Title, name, date of birth, gender, nationality, civil/marital
          status, contact details, addresses and documents that are necessary to
          verify your identity.
        </p>{" "}
        <p>
          -Employment and remuneration information, (including salary/bonus
          schemes/overtime/sick pay/other benefits), employment history.
        </p>{" "}
        <p>
          - Bank account details, tax information, loans and credit commitments,
          personal credit history, sources of income and expenditure, family
          circumstances and details of dependents.{" "}
        </p>{" "}
        <p>
          -Special Category Data. For example, health status and history,
          details of treatment and prognosis and medical reports.  (Further
          details are provided below with regard to the processing we may
          undertake in relation to this type of information).
        </p>{" "}
        <p>
          - Details of any pre-existing investment, protection or mortgage
          products and the terms and conditions relating to these.
        </p>
        <h3>
          {" "}
          The basis upon which our firm will deal with Your Personal Data
        </h3>{" "}
        <p>
          {" "}
          When we speak with you about your requirements, we do so on the basis
          that both parties are entering a contract for the supply of services.
          In order to perform that contract, and to arrange the products you
          require, we have the right to use Your Personal Data. We also need
          this in order to be able to provide you with fully and properly
          personalised advice, tailored to your specific circumstances.
        </p>
        <p>
          Alternatively, either in the course of initial discussions with you or
          when the contract between us has come to an end for whatever reason,
          we have the right to use Your Personal Data provided it is in our
          legitimate business interest to do so and your rights are not
          affected. For example, we may need to respond to requests from
          mortgage lenders, regulators, insurance providers and our Compliance
          Service Provider relating to the advice we have given to you, or to
          make contact with you to seek feedback on the service you received.
        </p>
        <p>
          On occasion, we will use Your Personal Data for contractual
          responsibilities we may owe our regulator, The Financial Conduct
          Authority, or for wider compliance with any legal or regulatory
          obligation to which we might be subject. In such circumstances, we
          would be processing Your Personal Data in order to meet a legal,
          compliance or other regulatory obligation to which we are subject.
        </p>
        <h3>
          {" "}
          The basis upon which we will process certain parts of Your Personal
          Data
        </h3>{" "}
        <p>
          When discussing your financial plans we will need to ask you about
          your ethnic origin, your health and medical history (Your Special
          Category Data). We will record and use your Special Category Data in
          order to ensure we recommend and use products that meet your needs
          fully. For example, health information can have an impact on
          underwriting for life cover, as well as on life expectancy when
          considering investments and pensions. We need to be able to ensure
          that we have sufficient information about these points to ensure that
          the products recommended are fully suited to your individual needs.
        </p>
        <p>
          If you have parental responsibility for children under the age of 13,
          we may need to record information on our systems that relates to those
          children and potentially, to their Special Category Data. This might
          be necessary if you have a child with a long-term health problem or
          disability, for example.
        </p>
        <p>
          {" "}
          The arrangement of certain types of insurance may involve disclosure
          by you to us of information relating to historic or current criminal
          convictions or offences (together “Criminal Disclosures”). This is
          relevant to insurance related activities such as underwriting, claims
          and fraud management.
        </p>
        <p>
          We will use Special Category Data and any Criminal Disclosures in the
          same way as Your Personal Data generally, as set out in this Privacy
          Notice. Information on Special Category Data and Criminal Disclosures
          must be capable of being exchanged freely between insurance
          intermediaries such as our Firm, and insurance providers, to enable
          customers to secure the important insurance protection that their
          needs require.
        </p>
        <h3>How do we collect Your Personal Data?</h3>
        <p>
          We will collect and record Your Personal Data from a variety of
          sources, but mainly directly from you. You will usually provide
          information during the course of our initial meetings or conversations
          with you to establish your circumstances and needs and preferences.
          You will provide information to us verbally and in writing, including
          email. We may also obtain some information from third parties, for
          example, credit checks, information from your employer, and searches
          of information in the public domain such as the voters roll. We may
          need to use technology solutions to assist in the collection of Your
          Personal Data, for example software that is able to verify your credit
          status.
        </p>
        <p>
          We will need to conduct an electronic ID check to comply with
          anti-money laundering rules. This will include a Politically Exposed
          Persons (PEP) and Sanctions check. On some occasions we may ask you to
          supply a Passport or Driving Licence number, as this can be required
          to complete an electronic ID check.
        </p>
        <h3>What happens to Your Personal Data when it is disclosed to us?</h3>
        <p>In the course of handling Your Personal Data, we will:</p>
        <p>
          - Record and store Your Personal Data in our paper files, mobile
          devices and on our computer systems.  This information can only be
          accessed by employees and consultants within our firm and only when it
          is necessary to provide our service to you and to perform any
          administrative tasks associated with or incidental to that service.
        </p>
        <p>
          {" "}
          - Submit Your Personal Data to Product Providers and Mortgage Lenders,
          both on paper and on-line via a secure portal. The provision of this
          information to a third party is essential in allowing us to progress
          any enquiry or application made on your behalf.  This will also enable
          us to verify your identification with the Provider, should any queries
          need to be resolved.
        </p>
        <p>
          {" "}
          - Use Your Personal Data for the purposes of responding to any queries
          you may have in relation to any product or policy you may take out, or
          to inform you of any developments in relation to those products or
          polices of which we might become aware.{" "}
        </p>
        <h3>Artificial Intelligence (AI)</h3>
        <p>
          AI is the development of computer systems that can perform tasks,
          typically requiring human intelligence, often by processing large
          amounts of data to achieve goals.{" "}
        </p>
        <p>
          To enhance the quality, efficiency, and accuracy of our services, we
          may use AI to assist with:
        </p>
        <p>
          - Recording and transcribing meetings, although you can opt out of
          being recorded.
        </p>
        <p> - Generating meeting notes and summaries</p>
        <p> - Drafting correspondence and documentation</p>
        <p>
          We are committed to protecting your privacy and ensuring that any
          information processed is handled securely.{" "}
        </p>
        <h3>Sharing Your Personal Data</h3>
        <p>From time to time Your Personal Data will be shared with:</p>
        <p>
          - Investment providers, Mortgage lenders and Insurance providers.{" "}
        </p>
        <p>
          -Third parties who we believe will be able to assist us with your
          enquiry or application, or who are able to support your needs as
          identified. These third parties will include but may not be limited
          to, our compliance advisers, product specialists, estate agents,
          providers of legal services such as estate planners, conveyancing,
          surveyors and valuers (in each case where we believe this to be
          required due to your particular circumstances) .{" "}
        </p>
        <p>
          In each case, Your Personal Data will only be shared for the purposes
          set out in this Customer Privacy Notice, i.e. to progress in helping
          us to meet your financial requirements, and to provide you with our
          professional services. Please note that this sharing of Your Personal
          Data does not entitle such third parties to send you marketing or
          promotional messages. It is shared to ensure we can adequately fulfil
          our responsibilities to you, and as otherwise set out in this Customer
          Privacy Notice.
        </p>
        <h3> Security and retention of Your Personal Data</h3>
        <p>
          {" "}
          Your privacy is important to us and we will keep Your Personal Data
          secure in accordance with our legal responsibilities. We will take
          reasonable steps to safeguard Your Personal Data against it being
          accessed unlawfully or maliciously by a third party.
        </p>{" "}
        <p>
          We also expect you to take reasonable steps to safeguard your own
          privacy when transferring information to us, such as not sending
          confidential information over unprotected email, ensuring email
          attachments are password protected or encrypted and only using secure
          methods of postage when original documentation is being sent to
          us.{" "}
        </p>
        <p>
          Your Personal Data will be retained by us either electronically or in
          paper format for a minimum of six years, or in instances whereby we
          have the legal right or regulatory requirement to hold records
          indefinitely for complaint handling purposes.{" "}
        </p>
        <h3>Your rights in relation to Your Personal Data</h3>
        <p> You can:</p>
        <p>
          - Request copies of Your Personal Data that is under our control;{" "}
        </p>
        <p>-Ask us to further explain how we use Your Personal Data; </p>
        <p>
          -Ask us to correct, delete or require us to restrict or stop using
          Your Personal Data (details as to the extent to which we can do this
          will be provided at the time of any such request);{" "}
        </p>
        <p>
          -Ask us to send an electronic copy of Your Personal Data to another
          organisation should you wish;{" "}
        </p>
        <p>
          -Change the basis of any consent you may have provided to enable us to
          market to you in the future (including withdrawing any consent in its
          entirety).
        </p>
        <p>
          Some data is provided jointly, for example on a joint mortgage.  If we
          are later asked by just one person to provide a copy of the data held,
          we will also need consent from the other person.
        </p>
        <p>
          {" "}
          This is because joint personal information provided for advice and
          applications cannot later be separated out.
        </p>{" "}
        <h3>
          How to make contact with our Firm in relation to the use of Your
          Personal Data
        </h3>
        <p>
          {" "}
          If you have any questions or comments about this document, Personal
          Data If you have any questions or comments about this document, or
          wish to make contact in order to exercise any of your rights set out
          within it please contact our principal firm:
        </p>{" "}
        <p>
          The Data Protection Officer, Rosemount Financial Solutions (IFA) Ltd,
          Rosemount House, 2-4 Chequers Road, Basingstoke, Hampshire, RG21 7PU.
          Tel: 01256 405460.{" "}
        </p>{" "}
        <p>
          If we feel we have a legal right not to deal with your request, or to
          action it in a different way to how you have requested, we will inform
          you of this at the time. You should also make contact with us as soon
          as possible on you becoming aware of any unauthorised disclosure of
          Your Personal Data, so that we may investigate and fulfil our own
          regulatory obligations.{" "}
        </p>{" "}
        <p>
          If you have a complaint about how we have handled Your Personal Data,
          please contact complaints@rosemountfsIFA.co.uk. We will carry out an
          investigation and respond to you with the outcome.{" "}
        </p>{" "}
        <p>
          If you remain dissatisfied after receiving our response, you may lodge
          a complaint with the UK's data protection regulator, the ICO, which
          can be contacted through their website at
          https://ico.org.uk/global/contact-us/ or by writing to Information
          Commissioner's Office, Wycliffe House, Water Lane, Wilmslow, Cheshire,
          SK9 5AF.
        </p>{" "}
        <p>
          {" "}
          Please keep this Privacy Notice stored safely along with the Client
          Agreement and any other advice related documents that you receive
          later in the process. The Declaration page on your Client Agreement
          makes reference to this Privacy Notice.{" "}
        </p>{" "}
        <p>
          {" "}
          Your declaration and signature will confirm your consent for us to
          process your personal data for the purposes stated in this Customer
          Privacy Notice.{" "}
        </p>{" "}
        <h3>Future contact with you</h3>
        <p>
          As part of ensuring that our advice to you remains suitable over the
          longer term, we may need to contact you in future.  As an example, we
          may need to do this if we have recommended a fixed term mortgage deal,
          where the term is shortly coming to an end.
        </p>
      </div>
    </>
  );
}

// Export the PrivacyPage component as default
export default PrivacyPage;
